import styled, { css } from 'styled-components';

export const StyledPageItemWrapper = styled.div`
  ${({ theme }) =>
    theme.Version === 'light' &&
    css`
      box-shadow: 8px 8px 25px 5px ${theme.Color.OverlayFixed.Light};
    `}
`;

export const StyledSvgContainer = styled.div`
  background-color: inherit;
  position: relative;
  box-sizing: border-box;
  overflow: visible;

  & > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
